import React from 'react';
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";


import img2 from "../../../assets/images/landing/features/img-2.png";
import img3 from "../../../assets/images/landing/features/img-3.png";
import img4 from "../../../assets/images/landing/features/img-4.png";
import img5 from "../../../assets/images/landing/features/img-5.jpg";

import customer_analytics from "../../../assets/images/customer-analytics.jpeg"
import customer_growth from "../../../assets/images/customer-growth.jpeg"
import sales_growth from "../../../assets/images/sales-growth.jpeg"

const Landing = () => {
    document.title = "AIMEE - Home";
    return (
        <React.Fragment>
            <div className="layout-wrapper landing">

                <Container>

                    <Row style={{ marginTop: "100px" }} className="align-items-center pt-lg-5 gy-4">
                        <Col lg={6} className="order-2 order-lg-1">
                            <div class="text-muted">
                                <h4 class="mb-3">CUSTOMER ANALYTICS SOLUTION</h4>
                                <p class="mb-4 ff-secondary">The Customer Analytics Solution comprises three distinct analytics tools: Audience Analytics, User Analytics, and Product Analytics. These tools provide deep insights into customer profiles beyond their immediate interactions with your business by analyzing demographics, preferences, and behaviors. Such AI based insights empower marketing, product design, and strategic planning efforts, enhancing your competitive edge and growth.</p>


                                <div class="d-flex justify-content-start mt-4 gap-3">
                                    <Link to="/audience" className="btn btn-primary">Audience Analytics</Link>
                                    <Link to="/profile" className="btn btn-primary">User Analytics</Link>
                                    <Link to="/pages-maintenance" className="btn btn-primary">Product Analytics</Link>
                                </div>
                            </div>

                        </Col>

                        <Col lg={6} sm={7} className="col-10 ms-auto order-1 order-lg-2">
                            <div>
                                <img src={customer_analytics} alt="" className="img-fluid" />
                            </div>
                        </Col>
                    </Row>

                </Container>
                <section className="section bg-light mt-5 py-3" id="features">
                    <Container>

                        <Row className="align-items-center  pt-lg-5 gy-4">
                            <Col lg={6} sm={7} className="col-10 mx-auto">
                                <div>
                                    <img src={customer_growth} alt="" className="img-fluid" />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="text-muted ">

                                    <h4 className="mb-3">CUSTOMER GROWTH SOLUTION</h4>
                                    <p className="mb-4">The Customer Growth Solution employs cutting-edge AI to refine customer acquisition, targeting spend-ready customers for cost-effective growth and a competitive market advantage.</p>

                                    <div className="mt-4">
                                        <Link to="/customer-growth" className="btn btn-primary">ENTER</Link>
                                    </div>

                                </div>
                            </Col>
                        </Row>



                    </Container>
                </section>


                <Container>

                    <Row className="align-items-center mb-5 mt-4 pt-lg-5 gy-4">
                        <Col lg={6} className="order-2 order-lg-1">
                            <div className="text-muted">

                                <h4 className="mb-3">SALES GROWTH SOLUTION</h4>
                                <p className="mb-4 ff-secondary">The AI-Enhanced Sales Growth Solution boosts sales and customer value by leveraging AI for insightful, personalized strategies that enhance performance metrics.</p>



                                <div className="mt-4">
                                    <Link to="/sales-growth" className="btn btn-primary">ENTER</Link>
                                </div>
                            </div>
                        </Col>

                        <Col lg={6} sm={7} className="col-10 ms-auto order-1 order-lg-2">
                            <div>
                                <img src={sales_growth} alt="" className="img-fluid" />
                            </div>
                        </Col>
                    </Row>
                </Container>

            </div>
        </React.Fragment>
    )
}

export default Landing;